export default {
  debtReminders: {
    stopTracking: "Stop tracking",
    stopTrackingHint: "Sending continues; the 3-day restriction remains.",
    pending: "Sending in progress",
    notification: "Notification",
    neverSent: "Never sent",
    debtCount: "Charges",
    notificationHistory: "Collection notifications",
    viewHistory: "History",
    cooldown: "Wait 3 days between emails",
    unknown: "Uncertain result; sending blocked for 3 days",
    simulated: "Simulated: no email was sent",
    lastAttempt: "Last attempt",
    nextAllowed: "Next allowed send",
    history: "Collection history (last 50 attempts)",
    noHistory: "No emails recorded",
    operator: "Requested by",
    chargeLink: "View charge",
    status: {QUEUED: "Scheduled",DELIVERED: "Delivered",READ: "Read",CANCELLED: "Cancelled",PREPARING: "Preparing",SENDING: "Sending / awaiting confirmation",ACCEPTED: "Accepted by email service",FAILED: "Confirmed failure",UNKNOWN: "Uncertain result",SIMULATED: "Simulated"},
    help: "Select people to send one email per debtor with all their overdue charges. Links require online payments. Up to 100 people per batch.",
    select: "Select",
    count: "Overdue movements",
    result: "Result",
    send: "Send collection email",
    filterAll: "Filter all movements",
    missingEmail: "No email registered",
    sent: "Email sent",
    noDebt: "No overdue charges remain",
    failed: "Failed: check email and payment link availability",
    busy: "Sending already in progress",
    sendError: "Unable to confirm sending. Check the result before trying again.",
    retry: "Try again",
  },
	title: "Finance Management",
	subtitle: "Temple financial management",
	menu: {
		dashboard: "Dashboard",
		funds: "Funds",
		movements: "Transactions",
		reports: "Closing",
		integrations: "Integrations",
	},
	categories: {
		title: "Fund Categories",
		newCategory: "New Category",
		editCategory: "Edit Category",
		name: "Name",
		fundsCount: "Linked funds",
		searchPlaceholder: "Search categories...",
		noCategories: "No categories registered",
		noCategoriesSubtext: "Create categories to organize your temple's funds",
		confirmDelete: "Are you sure you want to delete the category \"{name}\"?",
		stats: {
			total: "Categories",
		},
		validation: {
			nameRequired: "Name is required",
			nameMaxLength: "Name must be at most 100 characters",
		},
	},
	funds: {
		title: "Funds",
		newFund: "New Fund",
		editFund: "Edit Fund",
		name: "Name",
		category: "Category",
		description: "Description",
		createCategoryLink: "Create fund category",
		recurring: {
			label: "Enable recurring charges",
			hint: "Allows charging per person (membership fee, tithe) in the Charges tab. When off, the fund only receives one-off income.",
			disableNote: "To disable, the fund must have no active charges.",
		},
		isFeatured: "Featured",
		color: "Color",
		isFeaturedHint: "Featured funds appear at the top of the page with quick access",
		targetAmount: "Target amount",
		deadline: "Deadline",
		isActive: "Active",
		perpetual: "Perpetual",
		goalBased: "Goal-based",
		committed: "Expected",
		collected: "Collected",
		transferred: "Transferred",
		expenses: "Expenses",
		balance: "Balance",
		groupFlow: "Movement in the period",
		groupStatus: "Fund status",
		period: "Period",
		periodAll: "All time",
		windowMonthly: "per month",
		accumulatedBalance: "Accumulated balance",
		windowAccumulated: "all time",
		subscribers: "Subscribers",
		noFunds: "No funds registered",
		noFundsSubtext: "Create funds to manage the temple's income",
		searchPlaceholder: "Search funds...",
		featuredFunds: "Featured",
		allFunds: "All funds",
		filters: {
			category: "Category",
			status: "Status",
			active: "Active",
			inactive: "Inactive",
			clearFilters: "Clear filters",
		},
		stats: {
			total: "Funds",
			active: "Active",
			featured: "Featured",
			totalBalance: "Total balance",
		},
		validation: {
			nameRequired: "Name is required",
			nameMaxLength: "Name must be at most 150 characters",
			categoryRequired: "Category is required",
		},
	},
	fundTabs: {
		dashboard: "Dashboard",
		movements: "Movements",
		recorrencias: "Recurring",
		expenses: "Expenses",
	},
	income: {
		title: "New Income",
		modeNow: "Now",
		modeOpen: "Open (receivable)",
		modeInstallment: "Installments",
		modeRecurring: "Recurring",
		saved: "Income registered successfully",
		collisionTitle: "Open charge found",
		collisionText: "{name} already has {count} open charge(s) in this fund and month ({amount}). What would you like to do?",
		settleIt: "Settle it",
		createAnyway: "Create new income",
	},
	sales: {
		title: "Entries",
		newSale: "New Income",
		description: "Description",
		descriptionHint: "What it's for (e.g.: donation, extra fee, sale, raffle)",
		saleDate: "Date",
		personOptionalHint: "Optional — leave blank for an unidentified entry",
		saved: "Entry recorded successfully",
		searchPlaceholder: "Search by description or person...",
		noSales: "No entries recorded",
		noSalesSubtext: "Record one-off entries for this fund (donations, sales, collections)",
		totalThisView: "Total",
		modePaid: "Paid now",
		modeOpen: "Open (receivable)",
		filterAll: "All",
		filterOpen: "Open",
		filterPaid: "Paid",
		totalOpen: "Open",
		totalReceived: "Received",
	},
	charges: {
		title: "Charges",
		subscriptions: "Subscriptions",
		newCharge: "Create Charge",
		batchCharge: "Batch Charge",
		batchChargeTitle: "Batch Charge",
		batchChargeCreated: "{count} charges created",
		batchChargePartial: "{success} of {total} charges created",
		batchChargeAllFailed: "Could not create the charges",
		person: "Person",
		people: "People",
		amount: "Amount",
		mode: "Mode",
		recurring: "Recurring",
		oneTime: "One-time",
		lumpSum: "Lump sum",
		lumpSumDesc: "A single charge will be created.",
		recurringDesc: "A charge will be created every month.",
		oneTimeDesc: "One installment will be charged each month.",
		dueDay: "Due day",
		dueDayHint: "Day of month for due date (1-28)",
		nextChargeHint: "Next charge: created on {generated}, due on {due}",
		installments: "Installments",
		firstImmediate: "First installment due today",
		exempt: "Exempt",
		unexempt: "Remove exemption",
		exemptReason: "Exemption reason",
		exemptNotes: "Notes (sensitive data)",
		deactivate: "Deactivate charge",
		reactivate: "Reactivate",
		noCharges: "No charges in this fund",
		noChargesSubtext: "Create charges to manage payments",
		status: {
			active: "Active",
			exempt: "Exempt",
			inactive: "Inactive",
		},
		reasons: {
			FINANCIAL: "Financial",
			HEALTH: "Health",
			SENIOR: "Senior",
			LEADERSHIP: "Leadership",
			OTHER: "Other",
		},
		editCharge: "Edit Charge",
		editRecurrence: "Edit recurrence",
		history: "History",
		historyTitle: "Change History",
		noHistory: "No changes recorded",
		historyFields: {
			amount: "Amount",
			dueDay: "Due day",
			installments: "Installments",
		},
		searchPerson: "Search person...",
		maxInstallmentsHint: "Maximum {n} installments (fund deadline: {date})",
		enrollExempt: "Create as exempt",
		viewRecurrences: "Recurrences",
		viewCalendar: "Calendar",
		newOpenCharge: "New open charge",
		chargeCreated: "Open charge created",
		dueDate: "Due date",
		personOpenHint: "Who will settle this charge",
		pay: "Settle",
		payCharge: "Settle",
		chargePaid: "Settlement recorded",
		validation: {
			personRequired: "Person is required",
			personsRequired: "Select at least one person",
			amountRequired: "Amount is required",
			installmentsRequired: "Number of installments required for one-time",
			installmentsExceedDeadline: "Number of installments exceeds the fund deadline ({date})",
			exemptReasonRequired: "Exemption reason is required",
			descriptionRequired: "Description is required",
			dueDayRange: "Enter a day between 1 and 28",
			dueDateRequired: "Due date is required",
			dueDatePast: "Due date cannot be in the past",
		},
	},
	movements: {
		reversedTrail: "Reversal reason",
		title: "Movements",
		registerPayment: "Register Payment",
		amount: "Amount",
		amountPaid: "Amount paid",
		method: "Method",
		referenceMonth: "Reference month",
		notes: "Notes",
		anonymous: "Anonymous",
		anonymousHint: "Leave blank for anonymous mode",
		fund: "Fund",
		amountBelowCommitted: "Warning: amount is less than expected ({amount})",
		earlierMonthUnpaid: "Warning: there are earlier unpaid months",
		effectiveDate: "Effective date",
		cancel: "Cancel payment",
		confirmCancel: "Are you sure you want to cancel this payment?",
		reverse: "Reverse entry",
		reverseShort: "Reverse",
		confirmReverse: "Reverse this entry?",
		reversalReason: "Reversal reason",
		reopenCharge: "Set the charge back to pending",
		reopenChargeHint: "The person will owe this month again.",
		status: {
			PENDING: "Pending",
			PAID: "Paid",
			OVERDUE: "Overdue",
			WAIVED: "Waived",
			CANCELLED: "Cancelled",
			REVERSED: "Reversed",
			FORGIVEN: "Forgiven",
		},
		methods: {
			CASH: "Cash",
			PIX: "PIX",
			TRANSFER: "Transfer",
			OTHER: "Other",
		},
		noMovements: "No movements",
		attachment: "Receipt",
		attachmentHint: "Attach a receipt photo (optional)",
		residualForgiveWarning: "The amount entered is less than the charged amount. The difference will be forgiven — no additional charge will be generated.",
		residualCheckboxLabel: "Generate a charge for the remaining balance ({amount})",
		residualCheckboxHint: "Creates a new pending charge for the person to pay later. If unchecked, the difference is forgiven.",
		residualAlwaysInfo: "A charge for the remaining balance ({amount}) will be generated automatically.",
		forgivenReasonLabel: "Reason for forgiving {amount}",
		forgivenReasonHint: "Required: the temple is giving up this amount, and the accounts must say why.",
		partialSettleTrail: "Partial settlement",
		chargedAmount: "Amount charged",
		receivedAmount: "Amount received",
		forgivenAmount: "Forgiven amount",
		residualAmount: "Remaining balance",
		forgivenReasonTitle: "Reason for forgiving",
		validation: {
			forgivenReasonRequired: "Enter the reason for forgiving",
			amountRequired: "Amount is required",
			methodRequired: "Method is required",
			referenceMonthRequired: "Reference month is required",
			fundRequired: "Fund is required",
		},
	},
	movementFilters: {
		transfers: "Transfers",
		transferHint: "Transfers appear in the transfer total and realized balance. They are not included in Received or Paid.",
		applyHint: "Choose a range and click Apply. The chips below show the filters currently in use.",
		period: "Period",
		dateBasis: "Date basis",
		type: "Type",
		situation: "Status",
		from: "From",
		to: "To",
		apply: "Apply",
		invalidRange: "Enter a valid range with the start on or before the end.",
		search: "Search person, description or code…",
		more: "More filters",
		method: "Payment method",
		minAmount: "Minimum amount",
		maxAmount: "Maximum amount",
		invalidAmounts: "Enter valid amounts with minimum at or below maximum.",
		all: "All history",
		current: "This month",
		previous: "Previous month",
		custom: "Custom",
		reference: "Reference month",
		due: "Due date",
		paid: "Payment date",
		quickOverdue: "Overdue receivables",
		quickOverdueExpense: "Overdue payables",
		quickDueSoon: "Due in 7 days",
		quickWeek: "Payables this week",
		quickWeekIncome: "Receivables this week",
		quickToday: "Moved today",
		quickPaid: "Paid this month",
	},
	movementsPage: {
		exportCsv: "Export CSV",
		printReport: "Print",
		reportCount: "{count} of {total} records matching the selected filters (limit: 2,000).",
		reportError: "Unable to generate the report. Please try again.",
		income: "Income",
		expense: "Expense",
		title: "Transactions",
		subtitle: "General statement of income, expenses and transfers",
		searchPerson: "Search by person...",
		allTypes: "All types",
		allFunds: "All funds",
		allCategories: "All categories",
		allStatuses: "All statuses",
		typeIncome: "Income",
		typeExpense: "Expense",
		typeTransfer: "Transfer",
		noMovements: "No transactions found",
		noMovementsSubtext: "Register income, expenses or transfers to view the statement",
		type: "Type",
		clearFilters: "Clear filters",
		dueWindow: "Due: {from} to {to}",
		totalsOfFilter: "Filter totals:",
		totalReceived: "Received",
		totalToReceive: "To receive",
		totalPaid: "Paid",
		totalToPay: "To pay",
		realizedBalance: "Realized balance",
		uncountedNotice: "Not included in these totals: {count} (reversed, cancelled or waived)",
		columns: {
			date: "Date",
			code: "Code",
			type: "Type",
			person: "Person",
			fund: "Fund",
			category: "Category",
			referenceMonth: "Ref. Month",
			amount: "Amount",
			method: "Method",
			status: "Status",
			description: "Description",
		},
		anonymous: "Anonymous",
	},
	grid: {
		title: "Contributions",
		member: "Member",
		noData: "No data to display",
		noDataSubtext: "Enroll people in this fund to see the grid",
		paymentDetail: "Payment Details",
		tooltipPaid: "Paid — click for details",
		tooltipPending: "Pending — click to register",
		tooltipOverdue: "Overdue — click to register",
		tooltipWaived: "Waived",
		tooltipExempt: "Exempt",
		tooltipCancelled: "Cancelled",
		tooltipReversed: "Reversed",
		tooltipSettledInMonth: "Settled in {month} — the charge belongs to this period, the money came in that month",
		tooltipForgivenInMonth: "Forgiven in {month} — the charge belongs to this period; the house waived it that month",
		tooltipEmpty: "No movement — click to register",
		avulsa: "One-off",
		chargesTitle: "Charges",
		seeInMovements: "View this person's movements",
		monthClosed: "Month closed — new entries are not allowed",
		multipleCharges: "{count} charges this month",
		newCharge: "New charge",
		months: {
			"10": "Oct",
			"11": "Nov",
			"12": "Dec",
			"01": "Jan",
			"02": "Feb",
			"03": "Mar",
			"04": "Apr",
			"05": "May",
			"06": "Jun",
			"07": "Jul",
			"08": "Aug",
			"09": "Sep",
		},
	},
	personFinancial: {
		title: "Financial",
		noHistory: "No financial history",
		noHistorySubtext: "This person's payments will appear here",
		totalPaid: "Total paid",
		totalPending: "Total pending",
		totalOverdue: "Total overdue",
		paidAt: "Paid at",
	},
	dashboard: {
		viewMovements: "View",
		delinquentHint: "Overdue charges for people with outstanding debts, across all months. The dashboard counts people; each row here is a charge.",
		monthlyCollected: "Monthly Collected",
		goalPercent: "Goal Reached",
		remaining: "Remaining",
		overdueCount: "Overdue",
		featuredFunds: "Featured Funds",
		receivableTitle: "Accounts Receivable",
		payableTitle: "Accounts Payable",
		bucket: {
			overdue: "Overdue",
			dueIn7Days: "Due within 7 days",
			dueAfter7Days: "Due after 7 days",
			open: "Total",
		},
		committed: "Expected",
		collected: "Collected",
		noFeatured: "No featured funds",
		delinquents: "Delinquent Members",
		noDelinquents: "No delinquent members",
		totalDue: "Total Due",
		monthsOverdue: "months overdue",
		noChartData: "No data to display chart",
	},
	/**
	 * The cash valve (ISSUE-034): a charge from a closed month is never marked
	 * paid in that month — a receipt is created in the open month, and the
	 * already-presented report keeps saying what it said.
	 */
	settlement: {
		valveNotice:
			"The receipt goes into {openMonth}; cash in the closed period {originMonth} stays unchanged.",
		valveNoticeByDueDate:
			"The receipt goes into {openMonth}; cash in {closedMonth}, closed at the due date, stays unchanged.",
		integralOnly:
			"Closed month: full settlement only. For a partial amount or forgiveness, use Forgive.",
		settledInMonth: "Settled in {month}",
		settledInMonthHint: "The charge stays in this period; the money came in on {month}.",
		legendSettledInMonth: "Settled in another month (closed period)",
		receiptOf: "Receipt for period {month}",
		forgivenInMonth: "Forgiven",
		forgivenInMonthHint: "Forgiven in {month}; the period stays as is.",
		forgivenPartialHint: "Received; the remainder was forgiven",
		forgivenReason: "Reason for forgiveness",
		legendForgivenInMonth: "Forgiven",
		forgivenessOf: "Forgiveness for period {month}",
		forgivenessOfHint: "Original charge #{code}, from {month}.",
		closedPeriodForgiveness: {
			title: "Forgiveness of closed periods",
			hint: "Breakdown by originating period. Already counted in Charge forgiveness.",
			column: "Originating period",
			received: "Received",
			forgiven: "Forgiven",
			full: "Full",
			partial: "Partial",
		},
		closedPeriodReceipts: {
			title: "Receipts from closed periods",
			hint: "Already included in this month's income. The originating periods keep their charges open, exactly as stated in that month's document.",
			column: "Originating period",
		},
	},
	/** Forgiving a closed-month charge (ISSUE-036): a forgiveness entry is posted in the open month; the closed month stays as it was. */
	forgiveness: {
		title: "Forgive closed-month charge",
		action: "Forgive",
		actionTooltip: "Forgive closed-month charge",
		insteadOfPaying: "Forgive instead of receiving",
		notice:
			"{originMonth} is closed. The forgiveness goes into {openMonth}; {originMonth} stays as is.",
		noticeByDueDate:
			"Due in {closedMonth}, a closed month. The forgiveness goes into {openMonth}; {closedMonth} stays as is.",
		reasonLabel: "Reason for forgiveness",
		reasonHint: "Recorded in the financial statement",
		reasonRequired: "Enter the reason for forgiveness",
		partialSwitch: "I received part of it",
		amountLabel: "Amount received",
		amountInvalid: "Above zero and below the charged amount",
		methodRequired: "Enter the method",
		forgivenSummary: "Forgiven: {amount}",
		receivedSummary: "Received: {amount}",
		success: "Charge forgiven. Entry in {month}.",
		confirm: "Forgive",
	},
	report: {
		title: "Report",
		totalCollected: "Total Collected",
		totalCommitted: "Total Expected",
		adherence: "Adherence",
		adherenceNoBase: "no closed month with charges",
		chargesActive: "Active charges",
		allMovements: "Movements",
		registeredBy: "Registered by",
		timeProgress: "Time Progress",
		elapsed: "Elapsed",
		remaining: "Remaining",
		chartTitle: "Monthly Collection",
		noChartData: "No data to display chart",
		searchPerson: "Search person...",
	},
	insights: {
		analysisTitle: "Period analysis",
		periodAll: "All history",
		periodLast6: "Last 6 months",
		periodLast12: "Last 12 months",
		periodCustom: "Custom period",
		startMonth: "From",
		endMonth: "To",
		applyPeriod: "Apply",
		invalidRange: "The start month must be before or equal to the end month.",
		appliedPeriod: "Displayed period",
		periodScope: "applies to the cards and charts below",
		pendingTitle: "Current outstanding charges",
		pendingHint: "Today's position across all months. This section is independent of the period filter.",
		flowHint: "Paid income and expenses by reference month, including transfers. Compare the amounts to understand changes in the balance.",
		prevRealHint: "Expected subscription charges and the amount already paid for each reference month. The current month is still in progress.",
		adherenceHint: "Percentage of expected subscription charge amounts already paid. Months without expected charges have no point; the current month can still change.",
		agingHint: "Outstanding amounts from all months, grouped by days past due. “Current” includes charges not yet due or without a due date.",
		topDebtorsHint: "The five people with the highest outstanding amounts across all months, including charges not yet due.",
		methodHint: "Paid income by payment method for the reference months shown, excluding transfers between funds.",
		categoryHint: "Paid, categorized expenses for the displayed period. Expenses without a category are excluded from this chart.",
		balanceEvolutionTitle: "Fund balance over time",
		balanceEvolutionHint: "Balance by reference month, including transfers. Payments for future reference months appear in their respective month. Current month is in progress.",
		zeroBalance: "Zero balance",
		currentPosition: "Current position · all months",
		adherenceTitle: "Monthly adherence",
		agingTitle: "Overdue by aging",
		flowTitle: "Income and expenses",
		methodTitle: "Received by method",
		open: "Outstanding",
		balance: "Balance",
		income: "Income",
		expense: "Expenses",
		agingCurrent: "Current",
		aging1_30: "1–30 days",
		aging31_60: "31–60 days",
		aging60plus: "60+ days",
		noData: "No data to display",
		noOpen: "No outstanding charges",
		prevRealTitle: "Expected vs. received",
		expected: "Expected",
		received: "Received",
		topDebtorsTitle: "Top debtors",
		cumulativeTitle: "Cumulative balance",
		categoryTitle: "Expenses by category",
	},
	settings: {
		title: "Settings",
	},
	expenseCategories: {
		title: "Expense Categories",
		newCategory: "New Category",
		editCategory: "Edit Category",
		searchPlaceholder: "Search category...",
		noCategories: "No expense categories",
		noCategoriesSubtext: "Create categories to classify the temple's expenses",
		movementsCount: "movements",
		confirmDelete: "Are you sure you want to delete \"{name}\"?",
		stats: {
			total: "Total",
		},
	},
	expenses: {
		registerExpense: "Register Expense",
		category: "Expense Category",
		fromFund: "From which fund",
		description: "Description",
		descriptionPlaceholder: "E.g.: Electric bill February, 10kg rice...",
		register: "Register",
		validation: {
			categoryRequired: "Category is required",
		},
		scheduleExpense: "Schedule Expense",
		payNow: "Pay now",
		scheduleLater: "Schedule",
		recurring: "Recurring",
		dueDate: "Due date",
		dueDateRequired: "Due date is required for scheduled expenses",
		scheduledSuccess: "Expense scheduled successfully",
		payExpense: "Pay expense",
		expensePaid: "Expense paid successfully",
		methodRequiredForPayment: "Payment method is required",
	},
	recurringExpenses: {
		title: "Recurring Expenses",
		newExpense: "New Recurring Expense",
		editExpense: "Edit Recurring Expense",
		name: "Name",
		namePlaceholder: "E.g.: Rent, Electric Bill...",
		category: "Category",
		fund: "Source fund",
		dueDay: "Due day",
		dueDayHint: "Day of the month (1-28)",
		expectedAmount: "Expected amount",
		isFixed: "Fixed amount",
		isVariable: "Variable amount",
		fixedHint: "The amount is always the same every month",
		variableHint: "The amount may change each month (e.g.: electric bill)",
		startDate: "Start date",
		endDate: "End date",
		endDateHint: "Leave blank for indefinite recurrence",
		active: "Active",
		inactive: "Inactive",
		deactivate: "Deactivate",
		activate: "Activate",
		editRecurring: "Edit recurring",
		noExpenses: "No recurring expenses",
		noExpensesSubtext: "Register expenses that repeat monthly, such as rent, utilities, and internet",
		searchPlaceholder: "Search recurring expenses...",
		generatedMovements: "Generated movements",
		validation: {
			nameRequired: "Name is required",
			categoryRequired: "Category is required",
			fundRequired: "Fund is required",
			dueDayRequired: "Due day is required",
			amountRequired: "Amount is required",
			startDateRequired: "Start date is required",
		},
		messages: {
			created: "Recurring expense created successfully",
			updated: "Recurring expense updated successfully",
			deactivated: "Recurring expense deactivated",
			activated: "Recurring expense activated",
		},
	},
	transfers: {
		title: "Transfer",
		fromFund: "Source Fund",
		toFund: "Destination Fund",
		description: "Description",
		descriptionPlaceholder: "E.g.: Transfer to party fund...",
		transfer: "Transfer",
		balance: "Balance",
		negativeBalanceWarning: "Warning: this transfer will leave the source fund with negative balance.",
		percentOfBalance: "Percentage of balance",
		validation: {
			fromFundRequired: "Source fund is required",
			toFundRequired: "Destination fund is required",
			sameFund: "Source and destination funds must be different",
			percentRange: "Enter a value between 1% and 100%",
		},
	},
	cashFlow: {
		totalBalance: "Total Balance",
		monthIncome: "Month Income",
		monthExpense: "Month Expenses",
		monthBalance: "Month Balance",
		chartTitle: "Cash Flow — Income vs Expenses",
		income: "Income",
		expense: "Expenses",
		balance: "Cumulative Balance",
	},
	messages: {
		categoryCreated: "Category created successfully",
		categoryUpdated: "Category updated successfully",
		categoryDeleted: "Category deleted successfully",
		expenseCategoryCreated: "Expense category created successfully",
		expenseCategoryUpdated: "Expense category updated successfully",
		expenseCategoryDeleted: "Expense category deleted successfully",
		fundCreated: "Fund created successfully",
		fundUpdated: "Fund updated successfully",
		errorLoading: "Error loading financial data",
		chargeCreated: "Charge created successfully",
		chargeExempted: "Exemption applied successfully",
		chargeUnexempted: "Exemption removed successfully",
		chargeReactivated: "Charge reactivated successfully",
		paymentRegistered: "Payment registered successfully",
		chargeUpdated: "Charge updated successfully",
		paymentCancelled: "Payment cancelled successfully",
		paymentReversed: "Payment reversed successfully",
		expenseRegistered: "Expense registered successfully",
		transferCompleted: "Transfer completed successfully",
		movementUpdated: "Movement updated successfully",
	},
	closing: {
		title: "Monthly Closing",
		subtitle: "Monthly closing control and reports",
		close: "Close Month",
		reopen: "Reopen Month",
		confirmClose: "Are you sure you want to close the month {month}? No one will be able to create, edit, or reverse movements for this month through the system.",
		confirmReopen: "Are you sure you want to reopen the month {month}?",
		reopenLosesProof: "Reopening ERASES this month's integrity hash: a report already printed can no longer be verified against the system. The note written at closing will also be replaced by the one you type below.",
		notes: "Notes",
		notesPlaceholder: "Reason for closing/reopening...",
		closingPreview: {
			heading: "Closing {month} leaves this behind:",
			charges: "{count} charge(s) to receive — {amount}",
			expenses: "{count} bill(s) to pay — {amount}",
			consequence: "Closing cancels nothing: the debt and the bill remain. Whatever is received or paid later is recorded in the open month it is registered in, and the movements and totals of {month} do not change.",
		},
		status: {
			OPEN: "Open",
			CLOSED: "Closed",
		},
		report: {
			title: "Monthly Report",
			incomeByFund: "Income by Fund",
			expenseByCategory: "Expense by Category",
			byMethod: "Receipts by Method",
			delinquents: "Delinquents",
			comparison: "Comparison with Previous Month",
			noData: "No data for this month",
			delta: "Variation",
			income: "Income",
			expense: "Expense",
			balance: "Balance",
			total: "Total",
			previousMonth: "Previous Month",
			openingBalance: "Opening balance",
			movementCount: "Movements",
			closedBy: "Closed by {user} on {date}",
			reopenedBy: "Reopened by {user} on {date}",
			noNotes: "No note was recorded.",
			previousClosings: "Previous closings for this month",
			previousClosingsHint: "Each reopening ends the previous closing. The integrity code below is the one printed on reports from that time — it stays valid for that version, even though the month was closed again afterwards.",
			versionNumber: "Closing {number}",
			supersededBy: "Reopened by {user} on {date}",
			waived: "Waived",
			forgiven: "Forgiven charges",
			closingBalance: "Closing balance",
		},
		partial: "Partial",
		partialBanner: "This report is partial — the month is still in progress.",
		closeSequential: "Close the month {month} before closing this one.",
		isClosable: "Ready for closing",
		viewReport: "View Report",
		backToList: "Back",
		recipients: {
			title: "Monthly closing email",
			description: "Send report by email when closing the month",
			admins: "Administrators",
			allUsers: "All users",
			corrente: "Active members (corrente)",
		},
		messages: {
			monthClosed: "Month closed successfully",
			monthReopened: "Month reopened successfully",
			error: "Error processing closing",
		},
	},
	payment: {
		title: "Online payments",
		feeConfig: {
			title: "Mercado Pago fee posting",
			description:
				"Mercado Pago charges a fee per transaction (PIX 0.99%, card ~4.98%) and deducts it before the money reaches the temple's account — so less comes in than what the member paid. To keep your accounting accurate, ORI keeps the payment at its full amount and automatically posts that difference as a \"Mercado Pago fee\" expense, linked to the original entry. This way, the fund balance reflects exactly the net amount actually received.",
			example:
				"Example: the member pays R$50.00 via PIX → the temple receives R$49.50 and ORI records a R$0.50 expense (\"Mercado Pago fee - mov 260100\"). The fund balance shows the R$49.50 that actually came in.",
			enabledLabel: "Post the Mercado Pago fee as an expense",
			fundSame: "In the same fund that received the payment",
			fundFixed: "Always in a specific fund",
			fundSelect: "Fund for the fee expense",
			noFunds: "No funds registered",
			disableTitle: "Disable fee posting?",
			disableWarning:
				"We strongly recommend keeping this option enabled.\n\nWithout fee posting, your fund balances will be overstated: the system records the full amount charged to the member, but the temple's Mercado Pago account receives less, because the fee was already deducted. Your accounting will no longer reflect the money that actually came in.\n\nDisable only if you are fully aware of this discrepancy and intend to reconcile the fee manually.",
			disableConfirm: "Disable anyway",
			saveSuccess: "Fee configuration saved",
			saveError: "Failed to save the fee configuration",
		},
		autoDebitConfig: {
			enabledLabel: "Allow automatic charges (recurring card debit)",
			description:
				"When enabled, members can authorize the monthly automatic debit and you can activate it on charges. When off, only PIX is offered — the automatic charge button no longer appears. Automatic debits already authorized remain active and can be paused or cancelled.",
			saveSuccess: "Automatic charge preference saved",
			saveError: "Failed to save the automatic charge preference",
		},
		consent: {
			title: "Before connecting Mercado Pago",
			intro:
				"By connecting your account, members' payments will be processed by Mercado Pago. Before continuing, confirm that you understand that:",
			fees:
				"Mercado Pago charges a fee per transaction (PIX 0.99%, credit card ~4.98%), deducted automatically. ORI charges nothing extra.",
			netAmount:
				"The amount deposited into the temple's account will be lower than what the member paid, because the fee is deducted before release.",
			feeExpense:
				"ORI automatically posts that fee as a \"Mercado Pago fee\" expense in Finance, so the fund balances reflect the net amount received (adjustable in the integration settings).",
			responsibility:
				"Fees, release times and policies are the responsibility of Mercado Pago, not ORI. You are responsible for the connected account and for verifying the amounts received.",
			checkbox: "I have read and agree to the conditions above.",
			confirm: "Connect Mercado Pago",
		},
		connect: "Connect Mercado Pago",
		disconnect: "Disconnect",
		connected: "Connected",
		connectedAs: "Account: {account}",
		fees: "Mercado Pago fees: PIX 0.99% · card ~4.98% (~3.98% after 30 days). ORI charges nothing extra.",
		expired: "Expired",
		revoked: "Disconnected",
		notConnected: "No payment account connected",
		moduleMissing:
			"ORI Payments (Mercado Pago integration) is not included in your plan. Add the module on the plan screen to connect.",
		connectRequired: "Connect Mercado Pago in Integrations to use this feature",
		connectSuccess: "Payment account connected successfully",
		connectError: "Failed to connect the payment account",
		charge: {
			button: "Charge online",
			generating: "Generating charge...",
			copyLink: "Copy link",
			linkCopied: "Link copied",
			created: "Charge created",
			error: "Failed to create the charge",
			emailSent: "Sent by email to",
		},
		mandate: {
			enable: "Automatic charging",
			column: "Automatic charging",
			manualBlocked:
				"This charge is on automatic debit — Mercado Pago charges it automatically. Manual payment isn't allowed. Pause automatic charging to collect another way.",
			manualBlockedShort: "On automatic debit — manual payment blocked",
			pauseToPayManually: "Pause automatic charging",
			activate: "Enable automatic charging",
			resendLink: "Resend authorization link",
			pause: "Pause",
			resume: "Resume",
			cancel: "Cancel automatic charging",
			pausedSuccess: "Automatic charging paused",
			resumedSuccess: "Automatic charging resumed",
			cancelledSuccess: "Automatic charging cancelled",
			authorizePrompt: "Enable automatic monthly charging for this subscription.",
			confirmCancelTitle: "Cancel automatic charging?",
			confirmCancelText:
				"The automatic monthly debit will stop. You can enable it again later.",
			state: {
				NONE: "Automatic charging: off",
				PENDING: "Waiting for member to authorize",
				AUTHORIZED: "Automatic charging: active",
				PAUSED: "Automatic charging: paused",
			},
			tip: {
				NONE: "Automatic charging off. Enable it so the member can authorize the monthly debit.",
				PENDING: "Waiting for the member to authorize the automatic debit via the link sent.",
				AUTHORIZED:
					"Automatic charging active — the member is debited every month. Pausing stops it without cancelling.",
				PAUSED: "Automatic charging paused — debits are suspended. Resume to charge again.",
			},
		},
		status: {
			PENDING: "Pending",
			AUTHORIZED: "Authorized",
			PAUSED: "Paused",
			CANCELLED: "Cancelled",
			PAID: "Paid",
			EXPIRED: "Expired",
			FAILED: "Failed",
		},
	},
	pay: {
		loading: "Loading...",
		notFound: "Charge not found or expired",
		autoMandateTitle: "Tired of paying every month?",
		autoMandateText:
			"Enable automatic charging and stop paying manually — authorize once and you're done.",
		enableAutoMandate: "Enable automatic charging",
		autoMandateError: "Could not enable automatic charging. Please try again.",
		title: "Payment",
		amount: "Amount",
		temple: "Temple",
		month: "Month",
		payWith: "Pay with",
		pixTab: "PIX copy and paste",
		cardTab: "Card",
		copyCode: "Copy PIX code",
		codeCopied: "Code copied!",
		paid: "Payment confirmed",
		expiredHint: "The PIX code has a limited validity. Generate a new one to pay now.",
		noPaymentDue: "This charge is closed. No payment is due.",
		forgiven: "Charge forgiven by the house. Nothing to pay.",
		generateNewPix: "Generate new PIX",
		generateNewPixError: "Could not generate a new PIX. Please try again.",
		expired: "This charge has expired",
		authorize: "Authorize automatic charging",
		pixExpiryNotice: "This PIX code expires {time}. Do not schedule the payment.",
		autoDebitUnavailable:
			"Automatic charging is no longer available at this temple. Please contact the administration to arrange another payment method.",
	},
};
